'use strict';

export default {
  translation: 'Icon-translation',
  driving: 'Icon-pickupDriving',
  shopping: 'Icon-shoppingGuide',
  nightlife: 'Icon-nightlifeBars',
  food: 'Icon-foodRestaurants',
  museums: 'Icon-artMuseums',
  recreation: 'Icon-sportsRecreation',
  culture: 'Icon-historyCulture',
  sightseeing: 'Icon-citySightseeing'
};



// WEBPACK FOOTER //
// ./app/src/constants/activity_icons.js